// Uclean-Admin-Dashboard/src/mocks/promo/promoCodes/store.js

import fixtures from './fixtures.json';

export let codesStore = [...fixtures];

export const _resetCodesStore = () => {
  codesStore = [...fixtures];
};
